var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUmbauenUndSanieren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 306,
    viewBox: "0 0 457 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Umbauen und Sanieren"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.822 304.862L0.224487 168.057L0.26567 148.975L36.7477 134.363L262.995 260.745L252.47 295.509L236.822 304.862Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.819 305.105L0.231018 168.508V165.97L236.819 302.711V305.105Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.776 178.359L236.817 305.106L236.817 253.084L421.008 143.938L456.76 158.768L456.776 178.359Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.231018 149.026L236.813 286.314L456.761 158.767L220.034 33.9336L0.231018 149.026Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 412",
    d: "M269.28 121.752L284.27 109.314L347.698 144.983L321.418 159.309L269.28 121.752Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 413",
    d: "M209.734 223.569L295.622 174.117L323.863 158.023L337.582 150.494L370.282 171.52L234.986 239.975L209.734 223.569Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Haus mit Ger\xC3\xBCst"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haus bauf\xC3\xA4llig"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M316.988 83.9367L316.691 161.604L235.763 117.138V38.8779L263.925 0.933594L316.988 83.9367Z",
    fill: "#92733E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 57",
    d: "M130.231 98.1659L235.763 38.8779L316.988 83.9368L216.198 140.557L130.231 98.1659Z",
    fill: "#A07C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M260.664 112.032L211.152 144.66L129.928 98.4156L179.44 66.973L230.495 60.0753L254.026 95.5011L260.664 112.032Z",
    fill: "black",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M211.455 143.225V222.67L130.231 176.426V98.1658L158.096 59.6287L211.455 143.225Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.138 81.5652L211.455 143.225V222.67L321.434 159.233L321.138 81.5652ZM297.423 116.545L238.728 149.531V191.841L297.423 158.056V116.545Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M297.422 116.545L297.422 158.047L293.272 155.675L293.272 118.853L297.422 116.545Z",
    fill: "#B6B4AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M293.273 155.675L238.728 187.098V149.45L293.273 118.917V155.675Z",
    fill: "#66656E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M291.494 155.675L238.728 185.912V152.118L291.494 122.474V155.675Z",
    fill: "#B6B3AC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M290.308 155.082L238.728 184.726V154.489L290.308 124.666V155.082Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.211 70.8933L267.482 14.2733L264.222 9.23387L162.246 66.1503L165.211 70.8933Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.211 70.8933L267.482 14.2733L264.222 9.23387L162.246 66.1503L165.211 70.8933Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.641 143.225L314.913 86.6046L311.652 81.5652L209.677 138.482L212.641 143.225Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.641 143.225L314.913 86.6046L311.652 81.5652L209.677 138.482L212.641 143.225Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.808 77.1185L240.803 40.36L237.542 35.3205L170.843 72.3755L173.808 77.1185Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.808 77.1185L240.803 40.36L237.542 35.3205L170.843 72.3755L173.808 77.1185Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    d: "M161.654 57.85L216.198 140.557L211.455 143.225L158.096 59.6286L161.654 57.85Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 65",
    d: "M268.486 1.75476L324.809 87.1294L320.659 89.5009L264.929 3.5334L268.486 1.75476Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 66",
    d: "M264.929 3.53333L320.66 89.5008L316.509 91.8723L261.372 5.31196L264.929 3.53333Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 67",
    d: "M163.686 56.3502L220.01 141.725L215.86 144.096L160.129 58.1289L163.686 56.3502Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 68",
    d: "M160.129 58.1288L215.859 144.096L211.709 146.468L156.571 59.9074L160.129 58.1288Z",
    fill: "#D6B472"
  }), /*#__PURE__*/React.createElement("g", {
    id: "UmbauBalken4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 57_2",
    d: "M250.585 9.82678L306.909 95.2014L302.759 97.5729L247.028 11.6054L250.585 9.82678Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 58",
    d: "M247.028 11.6055L302.759 97.573L298.609 99.9445L243.471 13.3841L247.028 11.6055Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UmbauBalken3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 59",
    d: "M229.834 22.2772L286.158 107.652L282.008 110.023L226.277 24.0559L229.834 22.2772Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 60",
    d: "M226.277 24.0559L282.008 110.023L277.858 112.395L222.72 25.8345L226.277 24.0559Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UmbauBalken2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 61",
    d: "M208.491 34.1349L264.814 119.509L260.664 121.881L204.934 35.9135L208.491 34.1349Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 62",
    d: "M204.934 35.9135L260.664 121.881L256.514 124.252L201.376 37.6921L204.934 35.9135Z",
    fill: "#D6B472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UmbauBalken1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 63",
    d: "M184.776 46.5853L241.099 131.96L236.949 134.331L181.219 48.364L184.776 46.5853Z",
    fill: "#F4D18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 64",
    d: "M181.219 48.3639L236.949 134.331L232.799 136.703L177.661 50.1425L181.219 48.3639Z",
    fill: "#D6B472"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ger\xC3\xBCst Gro\xC3\x9F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 43",
    d: "M323.426 130.301L325.211 129.408L344.85 140.12L343.064 141.013L323.426 130.301Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.426 130.301L343.064 141.013V142.798L323.426 132.086V130.301Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.426 130.301L343.064 141.013V142.798L323.426 132.086V130.301Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Foot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 24",
    d: "M321.641 97.2727L323.426 98.1654V163.329L321.641 162.436V97.2727Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M323.426 98.1654L325.212 97.2727V162.436L323.426 163.329V98.1654Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M323.427 96.3801L325.212 97.2728L323.427 98.1654L321.642 97.2728L323.427 96.3801Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.064 132.086L286.827 164.221V166.007L343.064 133.871V132.086Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.064 132.086L286.827 164.221V166.007L343.064 133.871V132.086Z",
    fill: "#747773"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 46",
    d: "M267.189 153.51L323.426 121.374L343.064 132.086L286.828 164.221L267.189 153.51Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 47",
    d: "M268.975 153.064L322.565 122.267L341.279 132.533L287.689 163.329L268.975 153.064Z",
    fill: "#615A59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 48",
    d: "M323.426 100.843L325.211 99.9507L344.85 110.662L343.064 111.555L323.426 100.843Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.426 100.843L343.064 111.555V113.34L323.426 102.629V100.843Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.426 100.843L343.064 111.555V113.34L323.426 102.629V100.843Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Foot_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 24_2",
    d: "M341.279 107.984L343.065 108.877V174.041L341.279 173.148V107.984Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25_2",
    d: "M343.064 108.877L344.85 107.985V173.148L343.064 174.041V108.877Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26_2",
    d: "M343.065 107.092L344.85 107.985L343.065 108.877L341.279 107.985L343.065 107.092Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.189 153.51L286.828 164.221V166.007L267.189 155.295V153.51Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.189 153.51L286.828 164.221V166.007L267.189 155.295V153.51Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.064 133.425L287.347 198.355V200.141L343.064 135.21V133.425Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.064 133.425L287.347 198.355V200.141L343.064 135.21V133.425Z",
    fill: "#747773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.279 132.979L287.347 196.124V198.355L343.064 133.425L341.279 132.979Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.279 132.979L287.347 196.124V198.355L343.064 133.425L341.279 132.979Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.064 111.555L286.827 143.691V145.476L343.064 113.34V111.555Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.064 111.555L286.827 143.691V145.476L343.064 113.34V111.555Z",
    fill: "#747773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.013 111.385L287.347 141.735V143.405L341.799 112.278L340.013 111.385Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.013 111.385L287.347 141.735V143.405L341.799 112.278L340.013 111.385Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33",
    d: "M265.924 162.316L267.709 161.424L287.347 172.135L285.562 173.028L265.924 162.316Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.924 162.316L285.562 173.028V174.813L265.924 164.102V162.316Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.924 162.316L285.562 173.028V174.813L265.924 164.102V162.316Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Foot_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 24_3",
    d: "M264.138 129.288L265.924 130.181V195.344L264.138 194.452V129.288Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25_3",
    d: "M265.924 130.181L267.709 129.288V194.452L265.924 195.344V130.181Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26_3",
    d: "M265.924 128.396L267.709 129.288L265.924 130.181L264.138 129.288L265.924 128.396Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Foot_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 24_4",
    d: "M207.901 161.424L209.686 162.316V227.48L207.901 226.587V161.424Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25_4",
    d: "M209.687 162.316L211.472 161.424V226.587L209.687 227.48V162.316Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26_4",
    d: "M209.687 160.531L211.472 161.424L209.687 162.316L207.901 161.424L209.687 160.531Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.562 164.102L229.325 196.237V198.022L285.562 165.887V164.102Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.562 164.102L229.325 196.237V198.022L285.562 165.887V164.102Z",
    fill: "#747773"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 27",
    d: "M209.686 185.525L265.923 153.39L285.562 164.102L229.325 196.237L209.686 185.525Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 32",
    d: "M211.472 185.079L265.062 154.282L283.777 164.548L230.186 195.344L211.472 185.079Z",
    fill: "#615A59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 31",
    d: "M209.686 191.774L211.472 190.881L231.11 201.593L229.325 202.486L209.686 191.774Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 35",
    d: "M209.686 164.994L211.472 164.102L231.11 174.813L229.325 175.706L209.686 164.994Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.686 164.994L229.325 175.706V177.491L209.686 166.78V164.994Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.686 164.994L229.325 175.706V177.491L209.686 166.78V164.994Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 37",
    d: "M265.924 132.859L267.709 131.966L287.347 142.678L285.562 143.571L265.924 132.859Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.924 132.859L285.562 143.571V145.356L265.924 134.644V132.859Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.924 132.859L285.562 143.571V145.356L265.924 134.644V132.859Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Foot_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 24_5",
    d: "M283.777 140L285.562 140.893V206.056L283.777 205.163V140Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25_5",
    d: "M285.562 140.893L287.348 140V205.163L285.562 206.056V140.893Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26_5",
    d: "M285.562 139.107L287.347 140L285.562 140.893L283.777 140L285.562 139.107Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Foot_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 24_6",
    d: "M227.539 172.135L229.325 173.028V238.192L227.539 237.299V172.135Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25_6",
    d: "M229.325 173.028L231.11 172.135V237.299L229.325 238.192V173.028Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26_6",
    d: "M229.325 171.243L231.11 172.135L229.325 173.028L227.54 172.135L229.325 171.243Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.686 185.525L229.325 196.237V198.022L209.686 187.31V185.525Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.686 185.525L229.325 196.237V198.022L209.686 187.31V185.525Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.686 191.774L229.325 202.485V204.271L209.686 193.559V191.774Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.686 191.774L229.325 202.485V204.271L209.686 193.559V191.774Z",
    fill: "#B3B2AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.562 165.441L231.11 229.265V231.05L285.562 167.226V165.441Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.562 165.441L231.11 229.265V231.05L285.562 167.226V165.441Z",
    fill: "#747773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.777 164.994L231.11 227.033V229.265L285.562 165.441L283.777 164.994Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.777 164.994L231.11 227.033V229.265L285.562 165.441L283.777 164.994Z",
    fill: "#D1D2D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.562 143.571L229.325 175.706V177.491L285.562 145.356V143.571Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.562 143.571L229.325 175.706V177.491L285.562 145.356V143.571Z",
    fill: "#747773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.777 142.678L231.11 173.028V174.697L285.562 143.571L283.777 142.678Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.777 142.678L231.11 173.028V174.697L285.562 143.571L283.777 142.678Z",
    fill: "#D1D2D6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Baum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M109.878 150.794C118.848 155.799 118.848 164.056 109.878 169.276C99.7741 174.388 87.8202 174.388 77.718 169.276C68.7498 164.273 68.7498 156.014 77.718 150.794C87.8202 145.682 99.7741 145.682 109.878 150.794Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M92.0292 160.677L86.9354 130.065C87.0575 131.314 86.4347 132.266 85.0663 133.126C82.4746 134.756 78.1783 134.981 75.4713 133.55C74.0648 132.808 73.3659 131.83 73.3802 130.804L73.3768 130.804L70.307 162.745C70.1462 164.546 71.2863 166.324 73.7095 167.604C78.1312 169.941 85.1496 169.644 89.3831 166.982C92.2116 165.203 93.0788 162.77 92.0292 160.677Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M68.5167 72.1233C82.681 72.1233 94.164 83.9654 94.164 98.5721C94.164 113.179 82.681 125.021 68.5167 125.021C54.3514 125.021 42.8694 113.179 42.8694 98.5721C42.8694 83.9654 54.3514 72.1233 68.5167 72.1233Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M82.996 92.4516C74.5544 97.0775 60.8777 97.0775 52.436 92.4516C48.5888 90.396 46.5585 87.6207 46.1312 84.947C45.7029 88.3404 47.734 91.7311 52.436 94.3013C60.8777 98.9271 74.5544 98.9271 82.996 94.3013C87.5923 91.7311 89.7291 88.3386 89.3018 84.947C88.8735 87.7224 86.8451 90.3917 82.996 92.4516Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M85.2597 111.022C75.5675 116.226 59.8646 116.226 50.1723 111.022C45.7551 108.71 43.4241 105.587 42.9334 102.579C42.4417 106.397 44.7737 110.212 50.1723 113.103C59.8646 118.307 75.5675 118.307 85.2597 113.103C90.5369 110.212 92.9903 106.395 92.4997 102.579C92.0079 105.702 89.679 108.705 85.2597 111.022Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M90.9584 84.947C105.123 84.947 116.606 96.7892 116.606 111.396C116.606 126.002 105.123 137.845 90.9584 137.845C76.7931 137.845 65.311 126.002 65.311 111.396C65.311 96.7892 76.7931 84.947 90.9584 84.947Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M106.805 105.275C98.0508 109.901 83.8675 109.901 75.1132 105.275C71.1235 103.22 69.0181 100.444 68.5749 97.7706C68.1308 101.164 70.2371 104.555 75.1132 107.125C83.8675 111.751 98.0508 111.751 106.805 107.125C111.572 104.555 113.788 101.162 113.344 97.7706C112.9 100.546 110.797 103.215 106.805 105.275Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M109.304 123.846C99.612 129.05 83.9091 129.05 74.2168 123.846C69.7996 121.533 67.4686 118.411 66.9779 115.403C66.4862 119.221 68.8182 123.035 74.2168 125.927C83.9091 131.131 99.612 131.131 109.304 125.927C114.581 123.035 117.035 119.219 116.544 115.403C116.052 118.525 113.723 121.528 109.304 123.846Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M68.5172 107.388C78.2551 107.388 86.1497 115.642 86.1497 125.822C86.1497 136.003 78.2551 144.256 68.5172 144.256C58.7785 144.256 50.8846 136.003 50.8846 125.822C50.8846 115.642 58.7785 107.388 68.5172 107.388Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M78.4686 122.635C72.5282 126.104 62.9038 126.104 56.9634 122.635C54.2561 121.093 52.8274 119.011 52.5267 117.006C52.2253 119.551 53.6546 122.094 56.9634 124.022C62.9038 127.491 72.5282 127.491 78.4686 124.022C81.703 122.094 83.2067 119.55 82.906 117.006C82.6046 119.088 81.1772 121.09 78.4686 122.635Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M80.9681 135.458C74.0897 138.928 62.9457 138.928 56.0673 135.458C52.9326 133.917 51.2783 131.835 50.9301 129.83C50.5811 132.375 52.2361 134.918 56.0673 136.846C62.9457 140.315 74.0897 140.315 80.9681 136.846C84.7132 134.918 86.4543 132.374 86.1061 129.83C85.7571 131.911 84.1044 133.913 80.9681 135.458Z",
    fill: "#D9D9D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbauenUndSanieren);
export default __webpack_public_path__ + "static/media/UmbauenUndSanieren.2a597ee7c93398a4a1126861505dfe58.svg";
export { ForwardRef as ReactComponent };